
import { DepositAlternatives } from '../types'
import { PantaFormStepPassedProps } from "@sharedComponents/PantaForm/types";
import { IHeard, IMunicipality } from "@apps/Shared/Services/CompanyRegistrations/interfaces";

export interface Step3Props extends PantaFormStepPassedProps {
    cmsContent?: any
    formValues: any
    setFormValues: any
    rehydrateFormKey: boolean
    municipalities: IMunicipality[]
    heards: IHeard[]
    unexpectedErrors: string[]
}

export const depositAlternativeOptions = (t: Function) => {
    return [
        {
            label: t('companyRegistration.customer.depositAlternativePex'),
            value: DepositAlternatives.Pex,
        },
        {
            label: t('companyRegistration.customer.depositAlternativeBags'),
            value: DepositAlternatives.Bags,
        },
    ]
}